export const CamionType = [
  "TRUCK_3T",
  "TRUCK_5T",
  "TRUCK_8T",
  "TRUCK_7T",
  "TRUCK_9T",
  "TRUCK_10T",
  "TRUCK_12T",
  "TRUCK_15T",
  "TRUCK_20T",
  "TRUCK_25T",
  "TRUCK_30T",
  "TRUCK_35T",
  "TRUCK_50T",
];
